import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MuiTextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { memo } from 'react';
import { Edit, FormDataConsumer, Labeled, RecordContextProvider, SaveButton, SaveContextProvider, SimpleForm, TextField, TextInput, Toolbar, useAuthProvider, useNotify } from 'react-admin';
import { Controller, useForm } from 'react-hook-form';
import GridWrapper from 'utils/react-admin/GridWrapper';
import TextCopyField from 'utils/react-admin/TextCopyField';
import { AuthProviderEx, DecodedToken } from '../../ra-php-crud-api-auth';

export const CHOICES_USER_ROLE = [
  { id: 'system_admin', name: 'system_admin', },
  { id: 'edb', name: 'edb', },
  { id: 'school', name: 'school', },
];

export const CHOICES_USER_SCHOOL_TYPE = [
  { id: 'Others', name: 'Others', },
  { id: 'Primary', name: 'Primary', },
  { id: 'Secondary', name: 'Secondary', },
  { id: 'Special', name: 'Special', },
];

const EditActions = () => (
  <>
  </>
);

const EditToolbar = () => (
  <Toolbar >
    <SaveButton />
  </Toolbar>
);

function ChangePasswordForm(props: any) {
  const { authDecoded } = props;
  const { username } = authDecoded;
  const authProvider = useAuthProvider() as AuthProviderEx;
  const notify = useNotify();
  // const { } = useRecordContext();
  const { handleSubmit, reset, control } = useForm({
    defaultValues: {
      password: '',
      newPassword: '',
    }
  });
  const onSubmit = (data: any) => {
    const { password, newPassword } = data;
    authProvider.changePassword(username, password, newPassword).then(() => {
      notify('myroot.notify.auth.changePassword.success', { type: 'info' });
      reset();
    }).catch(() => {
      notify('myroot.notify.auth.changePassword.fail', { type: 'error' });
    });
  }
  return (
    <Card>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CardContent>
          <Typography variant="h6" gutterBottom>Change Password</Typography>
          <Grid spacing={2} container direction="column">
            <Grid item>
              <Controller
                name="password"
                control={control}
                render={({ field }) => <MuiTextField id="password" label="Password" type="password" autoComplete="current-password" variant="filled" fullWidth {...field} />}
              />
            </Grid>
            <Grid item>
              <Controller
                name="newPassword"
                control={control}
                render={({ field }) => <MuiTextField id="new-password" label="New Password" type="password" autoComplete="new-password" variant="filled" fullWidth {...field} />}
              />
            </Grid>
          </Grid>
        </CardContent>
        <Toolbar>
          <Button type="submit" variant="contained">Change Password</Button>
        </Toolbar>
      </form>
    </Card>
  );
}

function ChangePassword(props: any) {
  const save = (data: any) => {
    // console.log(1, data);
  }
  const saving = false;
  const mutationMode = "pessimistic";

  return (
    <RecordContextProvider value={{ password: '', newPassword: '' }}>
      <SaveContextProvider value={{ save, saving, mutationMode }}>
        <ChangePasswordForm {...props} />
      </SaveContextProvider>
    </RecordContextProvider>
  );
}

function MyProfile() {
  const authDecoded: null | DecodedToken = useAuthProvider().getDecoded();

  if (null === authDecoded) {
    return (<>Wrong Login Session</>);
  }

  return (
    <>
      <Box mt={2}>
        <Paper>
          <Edit resource="user" id={authDecoded.id} actions={<EditActions />} redirect={false}>
            <SimpleForm toolbar={<EditToolbar />}>
              <Typography variant="h6" gutterBottom>My Profile</Typography>
              <GridWrapper>
                <Grid item sm={4}><Labeled><TextField source="username" fullWidth /></Labeled></Grid>
                <Grid item sm={4}><Labeled><TextField source="role" fullWidth /></Labeled></Grid>
                <Grid item sm={4}><Labeled fullWidth><TextCopyField source="api_key" fullWidth /></Labeled></Grid>
                <Grid item sm={4}><TextInput source="email" fullWidth /></Grid>
              </GridWrapper>

              <FormDataConsumer>
                {({ formData, ...rest }) => (
                  'school' === formData.role ? <GridWrapper>
                    <Grid item sm={6}><Labeled><TextField source="school_code" fullWidth /></Labeled></Grid>
                    <Grid item sm={6}><Labeled><TextField source="school_type" fullWidth /></Labeled></Grid>
                    <Grid item sm={6}><Labeled><TextField source="school_display" fullWidth /></Labeled></Grid>
                    <Grid item sm={6}><Labeled><TextField source="school_phone" fullWidth /></Labeled></Grid>
                    <Grid item sm={6}><Labeled><TextField source="c_school_name" fullWidth /></Labeled></Grid>
                    <Grid item sm={6}><Labeled><TextField source="e_school_name" fullWidth /></Labeled></Grid>
                  </GridWrapper> : <></>
                )}
              </FormDataConsumer>
            </SimpleForm>
          </Edit>
        </Paper>
      </Box>
      <Box mt={2}>
        <Paper>
          <ChangePassword authDecoded={authDecoded} />
        </Paper>
      </Box>
    </>
  )
}

export default memo(MyProfile);
